/** Shared max-width + horizontal padding — keep in sync with `navigation.jsx` nav bar. */
export const APP_CONTENT_SHELL = {
  maxW: "1200px",
  mx: "auto",
  w: "100%",
  px: { base: 3, sm: 4, md: 6, lg: 8 },
};
